import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "antd";
import { getStorage } from "@/lib/webStorage";
import LoginForm from "./LoginForm";
import ForgotForm from "./ForgotForm";

interface props {
  dispatch: any;
  history: any;
}

interface state {
  isForgot: boolean;
}
class Login extends React.Component<props, state> {
  constructor(props: props) {
    super(props);
    this.state = {
      isForgot: false,
    };
  }
  copyRightYear = String(new Date().getUTCFullYear());

  componentDidMount() {
    const token = getStorage("token");
    const { history } = this.props;
    token && history.push("/home");
  }

  loginToForgot = () => {
    this.setState((prevState: any) => ({ isForgot: !prevState.isForgot }));
  };

  render() {
    const { history } = this.props;
    const { isForgot } = this.state;

    return (
      <div style={{ background: "fff" }}>
        <Row justify="center">
          <Col>
            {isForgot
              ? <ForgotForm
                dispatch={this.props.dispatch}
                loginToForgot={this.loginToForgot}
              />
              : <LoginForm
                history={history}
                loginToForgot={this.loginToForgot}
              />
            }
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(Login);